
import React from 'react';
import EmailCampaignForm from '@/components/email/EmailCampaignForm';
import EmailCampaignTable from '@/components/email/EmailCampaignTable';
import QuestionManagementMenu from '@/components/admin/QuestionManagementMenu';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';

const AdminEmailCampaigns = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 flex flex-col">
      <Header />
      <div className="flex-1 container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6">Email Campaigns</h1>
        <QuestionManagementMenu />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <EmailCampaignForm />
          <EmailCampaignTable />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AdminEmailCampaigns;
